import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Page from 'components/pages/Base/Page/Page';

const StyledGrantPage = styled(Page)`
  .GrantPage {
    &-loading {
      display: flex;
      flex-direction: column;
      align-items: center;
      row-gap: ${props => props.theme.layout('2sp')};

      width: 100%;
      text-align: center;
    }
  }
  
  ${ComponentStyles}
`;

StyledGrantPage.propTypes = {
  theme: PropTypes.object
};

export default StyledGrantPage;
